import React, { Component } from 'react';
import { VideoModalStyles } from './VideoModalStyles';

class VideoModalComponent extends Component {
  componentWillMount() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-open');
  }

  dismiss = () => {
    this.props.unmountMe();
  };

  render() {
    return (
      <VideoModalStyles>
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.dismiss}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    title="Youtube Video"
                    className="embed-responsive-item"
                    src={`https://www.youtube.com/embed/${this.props.videoId}?rel=0`}
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </VideoModalStyles>
    );
  }
}

export default VideoModalComponent;
